var _use, _defs, _symbol;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 2.5,
    y: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faae42",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ef3e31",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e39f3a",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d33929",
    offset: "100%"
  })))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "C",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.774 0h44.295c2.155 0 4.248.344 6.279 1.063C71.284 2.125 73.94 4 75.939 6.438c2.031 2.438 3.374 5.438 3.842 8.563.187 1.156.219 2.313.219 3.469v40.188 3.031c0 1.375-.062 2.781-.344 4.125-.625 3.094-2.093 6-4.217 8.344-2.093 2.344-4.842 4.094-7.809 5.031-1.812.563-3.686.813-5.592.813-.843 0-44.389 0-45.045-.031A17.82 17.82 0 0 1 7.997 77a18.06 18.06 0 0 1-6.091-7C.718 67.594.125 64.906.125 62.219V17.781c-.062-2.656.5-5.281 1.655-7.656 1.343-2.812 3.436-5.281 6.029-7.031C10.464 1.281 13.588.219 16.774.063c.312-.062.656-.062 1-.062z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.474 65.438c-.281-.437-.593-.875-.937-1.281a13.27 13.27 0 0 0-2.686-2.437c-1.25-.844-2.718-1.375-4.217-1.437-1.062-.062-2.124.125-3.124.5-1 .344-1.968.844-2.905 1.344l-3.342 1.594c-1.374.563-2.811 1-4.28 1.313-1.843.344-3.717.469-5.56.438-3.342-.062-6.685-.562-9.871-1.5-2.811-.844-5.498-2-8.028-3.469-2.218-1.281-4.28-2.75-6.216-4.406-1.593-1.375-3.061-2.844-4.436-4.406L9.184 48.25c-.344-.469-.656-.969-.937-1.469L0 37.875V17.719C0 7.938 7.903 0 17.681 0h15.775l11.683 11.875c26.365 17.938 17.837 37.719 17.837 37.719s7.497 8.438 4.498 15.844z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.201 11.875c26.365 17.938 17.837 37.719 17.837 37.719s7.497 8.469 4.467 15.875c0 0-3.093-5.187-8.278-5.187-4.998 0-7.934 5.188-17.993 5.188-22.397 0-32.987-18.719-32.987-18.719 20.18 13.281 33.956 3.875 33.956 3.875-9.09-5.281-28.426-30.531-28.426-30.531 16.837 14.344 24.116 18.125 24.116 18.125-4.342-3.594-16.525-21.156-16.525-21.156 9.746 9.875 29.114 23.656 29.114 23.656 5.498-15.25-5.279-28.844-5.279-28.844z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.35446ac8e49cac718f31b04591ea589b.svg";
export { ForwardRef as ReactComponent };